import axios from 'axios'

const SsoEnabledForUser = ( email, authToken ) => {
    let formData = new FormData();
    formData.append('authenticityToken', authToken);

    return axios.post(`/ssoEnabledForUserAJAX?mail=${email}`, formData )
    .then( res => {
        if( res.status === 200 ){
            return res
        }else{
            throw new Error(`POST /apply-now-notify/{prospectUid} responded with status ${res.status}`)
        }
    })
    .catch(function (error) {
        // TODO: come up with a error handling solution
        // maybe integrate with airbrake
        console.log( error )
    });
}

export default SsoEnabledForUser

